// PageMetaKey determines whether nuxtPage remounts(forcing all child components to do the same) during navigation
export enum PageMetaKey {
  PreviewPages = 'preview-cms-pages',
  CmsPages = 'cms-pages',
  // Prefer to deprecate the keys below when possible, and use cms-pages instead
  LandingPage = 'pages',
  Homepage = 'homepage',
}
